import React, { Component } from 'react';
import { CustomCard } from "../../../../components/Card/CustomCard";

import organigrama from "../../../../assets/img/OrganigramaIUDLM.jpg";

class Organigrama extends Component {
    state = {  }

    contenido = () => (
        <div id="organigrama">
            <img src={organigrama} className="img img-responsibe" alt="Organigrama"/>
        </div>
    )

    render() { 
        return (
            <CustomCard
                content={this.contenido()}
            /> 
        );
    }
}
 
export default Organigrama;


// WEBPACK FOOTER //
// ./src/site/Componentes/Institucion/Contenido/Organigrama.jsx